
export default {
  name: 'DefaultLayout',
}
